module.exports = __webpack_public_path__ + "img/9791185871509.a44409af.jpg";